import React from 'react';
import {
  Card, CardActionArea, CardActions, CardMedia, Theme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import {
  PlayArrow as PlayArrowIcon,
  VolumeUp as VolumeUpIcon,
  ZoomOutMap as ZoomOutMapIcon,
} from '@material-ui/icons';
import clsx from 'clsx';
import { ColorProperty } from 'csstype';

import { Space } from '../index';

const useStyles = makeStyles<Theme, Props>({
  card: {
    width: '240px',
    borderRadius: '0',
  },
  video: {
    height: '100px',
    backgroundColor: '#ccc',
  },
  videoTopLine: {
    height: '15px',
  },
  darkLine: {
    backgroundColor: ({ baseColor }) => baseColor,
  },
  videoBtnLine: {
    height: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

  },
  icon: {
    width: '15px',
    height: '15px',
    color: ({ accentColor }) => accentColor,
  },
  link: {
    width: '40px',
    height: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
}, { name: 'VideoPreview' });

type Props = {
  baseColor: ColorProperty;
  accentColor: ColorProperty;
};

const VideoPreview = ({
  baseColor,
  accentColor,
}: Props) => {
  const classes = useStyles({ baseColor, accentColor });

  return (
    <Card className={classes.card}>
      <CardActionArea>
        <div className={clsx(classes.videoTopLine, classes.darkLine)} />
        <CardMedia className={classes.video}>
          <Space />
        </CardMedia>
      </CardActionArea>
      <CardActions className={clsx(classes.videoBtnLine, classes.darkLine)}>
        <div className={classes.link}>
          <PlayArrowIcon className={classes.icon} />
          <VolumeUpIcon className={classes.icon} />
        </div>
        <ZoomOutMapIcon className={classes.icon} />
      </CardActions>
    </Card>
  );
};

export default VideoPreview;
